import { SurfaceType } from '@jms/model';
import type { SurfaceTypeDefinition } from '../../core/runtime/surfaces/surface.definition';
import { SURFACE_SCHEMA_SLOTS } from '../../core/runtime/surfaces/surface.schema.slots';

// Chat-bubble layout for agent-emitted forms. Stacked single-column body,
// no summary, no tabs. Submit goes through a chat callback contract.
// Trust-level policy validation pins agent-emitted schemas to this surface
// (plan §Schema trust levels).
export const agentSurface = {
  id: SurfaceType.Agent,
  saveStrategy: 'submit',
  defaultFieldMode: 'edit',
  slots: SURFACE_SCHEMA_SLOTS[SurfaceType.Agent],
} as const satisfies SurfaceTypeDefinition<SurfaceType.Agent>;
